"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _calculateTotal = _interopRequireDefault(require("../calculateTotal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createTableData = employees => {
  return employees.map(employee => {
    return {
      id: employee.id,
      nameOrNum: employee.nameOrNum,
      employmentGrade: employee.employmentGrade,
      specXFunc: employee.specXFunc.label,
      yearOfBirth: employee.yearOfBirth,
      grossSalary: (0, _calculateTotal.default)(employee, 'payroll'),
      absence: (0, _calculateTotal.default)(employee, 'absence'),
      orderRelatedAttendance: (0, _calculateTotal.default)(employee, 'orderRelatedAttendance'),
      nonOrderRelatedAttendance: (0, _calculateTotal.default)(employee, 'nonOrderRelatedAttendance'),
      remarks: employee.remarks
    };
  });
};
class TableController {
  constructor() {}
  getTableData(employees) {
    if (!employees) {
      throw "No Data For Employees Table";
    }
    return createTableData(employees);
  }
}
var _default = exports.default = TableController;